import { LicensePlate } from "./Vehicle";

export type ActivityFeedItem = {
  id: number;
  tenantID: number;
  propertyID: number;
  propertyName: string;
  contactID: number;
  contactName: string;
  timestamp: number;
  entityID: number;
  entityTypeID: number;
  plate: LicensePlate | null;
  type: ActivityFeedItemType;
  status: string;
};

export type ActivityFeedItemType = "tow" | "boot" | "tag" | "patrol" | "permit";

export enum PPIPusherEvent {
  PermitCreated = "permit_created",
  PermitUpdated = "permit_updated",
  PermitList = "permit_list",
  JobCreated = "job_created",
  JobUpdated = "job_updated",
  ActivityFeed = "activity_feed",
}
